import { Locales } from 'src/i18n'
import LocationTranslationJson from './interfaces/LocationTranslationJson'
import Translation from '../shared/interfaces/Translation'

export default class LocationTranslation implements Translation {
  locale: Locales
  name: string

  constructor(locale: Locales, name: string) {
    this.locale = locale
    this.name = name
  }

  static fromJson(data: LocationTranslationJson) {
    return new this(data.locale, data.name)
  }

  toJson(): LocationTranslationJson {
    return {
      locale: this.locale,
      name: this.name,
    }
  }
}
